import type { ReactNode } from 'react'
import { GiveDisclosures } from '@/components/donations/public-give-shared'
import { CampaignContext, type CampaignOption } from '@/pages/PublicGiveCampaignContext'

export function CampaignGiveLayout({
  campaigns,
  campaignId,
  wording,
  footer,
  children,
}: {
  campaigns: CampaignOption[]
  campaignId?: string
  wording?: string
  footer?: string
  children: ReactNode
}) {
  if (!campaignId) return <>{children}</>

  return (
    <div
      data-testid="campaign-give-layout"
      className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_380px] lg:items-start"
    >
      <div className="space-y-5">
        <CampaignContext campaigns={campaigns} campaignId={campaignId} />
        <GiveDisclosures wording={wording} footer={footer} />
      </div>
      {children}
    </div>
  )
}
